import { useMutation as f } from "@apollo/client";
import { accountSchema as v } from "../../deserialize/yup/account.js";
import { deserializeData as g } from "../../graphql/deserialize/index.js";
import C from "../../graphql/mutation/processEmailRegister.js";
import * as e from "ramda";
import { useState as b, useCallback as E } from "react";
const S = () => {
  const [t, { loading: i }] = f(C), [s, n] = b(null);
  return {
    mutate: E(
      async (r) => {
        const { email: c, otpCode: m, password: l, enableMarketingEvent: u, inviter: o } = r, p = e.isNil(o) ? {} : { invitationCode: e.pathOr("", ["invitation", "code"], o) }, d = await t({
          variables: {
            input: {
              otpCode: m,
              email: c,
              password: l,
              enableMarketingEvent: u,
              ...p
            }
          }
        }), a = g(d, v);
        return n(a), a;
      },
      [t]
    ),
    data: s,
    loading: i
  };
};
export {
  S as default
};
//# sourceMappingURL=useProcessEmailRegister.js.map
